import { Suspense, type ReactNode } from 'react';
import { refreshAdminAccess } from '@/entities/AccessManagement/model/refreshAdminAccess';
import { canAccessRoute, useAdminAccess } from '@/shared/model/adminAccess';
import { RequestStatus } from '@/shared/model/requestStatus';
import { RequestEmpty, RequestError, RequestLoading } from '@/shared/ui/RequestState';

interface AdminPermissionRouteProps {
    route: string;
    children: ReactNode;
}

/** Ограничивает прямой переход административными правами */
export const AdminPermissionRoute = ({ route, children }: AdminPermissionRouteProps) => {
    const status = useAdminAccess((state) => state.status);
    const error = useAdminAccess((state) => state.error);
    const allowed = useAdminAccess((state) => canAccessRoute(state.snapshot, route));

    if (status === RequestStatus.Idle || status === RequestStatus.Loading) {
        return <RequestLoading message="Загрузка прав доступа..." />;
    }

    if (status === RequestStatus.Error) {
        return (
            <RequestError
                message={error ?? 'Не удалось загрузить права доступа'}
                onRetry={refreshAdminAccess}
            />
        );
    }

    if (!allowed) return <RequestEmpty message="Нет доступа к этому разделу или действию" />;

    return (
        <Suspense fallback={<RequestLoading message="Загрузка раздела..." />}>
            {children}
        </Suspense>
    );
};
